function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-267.65 -15.65)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18.7,
  height: 18.7,
  transform: "translate(267.65 15.65)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M6.125,14a1.75,1.75,0,0,0,1.749-1.75h-3.5A1.75,1.75,0,0,0,6.125,14Zm5.89-4.094C11.486,9.339,10.5,8.485,10.5,5.688A4.318,4.318,0,0,0,7,1.445V.875a.874.874,0,1,0-1.749,0v.57a4.318,4.318,0,0,0-3.5,4.243c0,2.8-.988,3.651-1.517,4.219A.854.854,0,0,0,0,10.5a.876.876,0,0,0,.878.875H11.372a.876.876,0,0,0,.878-.875A.854.854,0,0,0,12.015,9.907Z",
  transform: "translate(271.097 18)"
}));

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.7,
    height: 18.7,
    viewBox: "0 0 18.7 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.e0593655.svg";
export { ForwardRef as ReactComponent };